var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","title":_vm.title}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-file-edit-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }